import { Button } from 'antd'
import { createStyles } from 'antd-style'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'

import { LoginWechat } from '@eastcoal/auth/components/Login/Wechat'
import { EaLogonIcon } from '@eastcoal/icon/EaLogonIcon'
import { useNavigate } from '@eastcoal/router/exports/react-router'

import { LoginType } from '../../enums/LoginType'
import { useLoginStore } from '../../hooks/useStore'
import { navigateWithTarget } from '../../utils/navigateWithTarget'

const useStyles = createStyles(({ token, prefixCls }) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBlock: token.paddingSM
  },
  switchIcon: {
    color: token.blue
  },
  switchBtn: {
    position: 'absolute',
    right: token.marginXS,
    top: token.marginXXS,
    padding: 'unset',
    [`&.${prefixCls}-btn .anticon`]: {
      fontSize: ` ${token.fontSizeHeading2}px`
    }
  }
}))

export const LoginScan = () => {
  const { loginType } = useLoginStore()
  const { modal } = useFeedback()
  const navigate = useNavigate()

  const handleSwitchLoginSms = () => {
    navigateWithTarget(navigate, `#${LoginType.SMS}`)
  }

  const handleLoginFail = () => {
    modal.confirm({
      title: '登录失败',
      content:
        '您的微信暂未绑定账号，请改用其他方式登录之后进行绑定，或立刻前往注册？',
      mask: {
        closable: false
      },
      okText: '改用其他登录',
      onOk: () => {
        navigateWithTarget(navigate, `#${LoginType.SMS}`)
      },
      cancelText: '前往注册',
      onCancel: () => {
        navigateWithTarget(navigate, '/register')
      }
    })
  }

  const { styles } = useStyles()

  return loginType === LoginType.WECHAT ? (
    <>
      <div className={styles.header}>
        <span>微信扫码登录</span>
        <Button
          className={styles.switchBtn}
          icon={<EaLogonIcon className={styles.switchIcon} />}
          title='手机登陆'
          type='text'
          onClick={handleSwitchLoginSms}
        />
      </div>
      <LoginWechat onFail={handleLoginFail} />
    </>
  ) : null
}
